import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasEmptyMessageComponent } from './gas-empty-message.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasButtonModule } from './../../forms/gas-button/gas-button.module';

const COMPONENTS = [
  GasEmptyMessageComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
    GasButtonModule,
  ],
})
export class GasEmptyMessageModule { }
